module.exports = __webpack_public_path__ + "img/avatar0.1d11f0bd.png";